export const trackEvent = (...args) => {
    if (import.meta.env.VITE_ENV == 'local' || !window._paq) return
    window._paq.push(['trackEvent', ...args])
}
